import { createContext, useContext } from 'react';
import { UserConsentFormType } from 'types/form';

export const UserConsentContext = createContext<UserConsentFormType | null>(null);

export function useUserConsentContext(): UserConsentFormType | null {
    return useContext(UserConsentContext);
}
